<style>
.v-list-item__title {
  white-space: normal;
}
</style>

<template>
  <div>
    <v-row v-if="missedDeliveryUnavailable">
      <v-col cols="12" sm="12">
        <v-card elevation="5" class="pa-2 text-center">
          <p class="px-10 py-5">
            Dear Customer, the Re-delivery service is currently unavailable while we carry out maintenance. We apologise for any inconvenience caused and appreciate your patience.
          </p>
        </v-card>
      </v-col>
    </v-row>

    <div v-if="!missedDeliveryUnavailable">
      <v-row v-show="showIntro">
        <v-col cols="12" sm="12">
          <v-card elevation="5" class="pa-2 text-center">
            <p class="px-10 py-5">
              Have your item redelivered to an address, (Sub) Post Office or Easipik parcel locker <br/><b>OR</b><br/>Have it kept at the (Sub) Post Office past the standard 12 working days, and collect it by your preferred date
            </p>
            <v-btn
              color="primary"
              @click="startRedeliveryRequest()"
              class="px-10 py-5 mb-5"
            >
              Start Request
            </v-btn>
          </v-card>
        </v-col>
      </v-row>

      <v-stepper v-model="currentStep" vertical v-show="!showIntro">
        <v-snackbar v-model="showSnackbar" :timeout="snackbarTimeout" top right color="red" text>
          {{ snackbarText }}
        </v-snackbar>

        <v-row>
          <v-col cols="12" sm="12">
            <v-card elevation="5" class="pa-1 text-center">
              <h4 class="px-10 py-1">{{ leadTimeMessage }}</h4>
              <h4 class="px-10 py-1">We can also hold your item up to a maximum of 12 weeks.</h4>
            </v-card>
          </v-col>
        </v-row>

        <Step01 />
        <Step02 />
        <Step03 />
        <Step04 />
      </v-stepper>
    </div>
  </div>
</template>

<script>
import Step01 from "./Steps/Step01";
import Step02 from "./Steps/Step02";
import Step03 from "./Steps/Step03";
import Step04 from "./Steps/Step04";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("missedDelivery");

export default {
  name: "Declaration",
  components: {
    Step01,
    Step02,
    Step03,
    Step04
  },
  data: () => ({
    missedDeliveryUnavailable: true,
    showIntro: true,
    isMounted: false,
  }),
  computed: {
    ...mapGetters([
      "currentStep",
      "snackbarTimeout",
      "snackbarText",
      "busy",
      "settings"
    ]),
    showSnackbar: {
      set(isSnackbarVisible) {
        this.$store.dispatch(
          "missedDelivery/setSnackbarVisibility",
          isSnackbarVisible
        );
      },
      get() {
        return this.$store.getters["missedDelivery/showSnackbar"];
      },
    },
    leadTimeMessage: {
      get() {
        const settings = this.settings;
        if (settings && settings.redeliveryLeadTimeInDays) {
          const dayString = settings.redeliveryLeadTimeInDays == 1 ? "day" : "days";
          return `The redelivery could take up to ${settings.redeliveryLeadTimeInDays} working ${dayString} from issuing the redelivery request.`;
        }
        return "";
      }
    },
    
  },
  methods: {
    startRedeliveryRequest: function () {
      this.showIntro = false;
      this.$store.dispatch("missedDelivery/startRedeliveryRequest");
    },
  },
  async mounted() {
    if (this.missedDeliveryUnavailable) {
      return;
    }

    await this.$store.dispatch("missedDelivery/pageLoad");
    this.isMounted = true;
  },
  beforeRouteLeave(to, from, next) {
    if (this.missedDeliveryUnavailable) {
      next();
      return;
    }

    const isSubmitting = this.$store.getters["missedDelivery/isSubmitting"];
    const isRedirectingBeforeEdits = this.$store.getters["missedDelivery/isRedirectingBeforeEdits"];

    if (isSubmitting || isRedirectingBeforeEdits) {
      next();
      return;
    }

    const answer = window.confirm('Are you sure you want to leave? Changes you made may not be saved.')
    if (answer) {
      next()
    } else {
      next(false)
    }
  }
};
</script>

<style scoped>
.md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

label.v-label.v-label--active {
  color: black;
}

.postCode .v-messages:before {
  content: "You can find your postcode on www.maltapost.com/postcode";
  color: #000;
}

.itemQuantity .v-messages:before {
  content: "How many item's does your package contain?";
  color: #000;
}

.itemValue .v-messages:before {
  content: "If the actual value is not known, an estimation value of the total package should be listed";
  color: #000;
}
</style>
